import { render, staticRenderFns } from "./HorizontalStep.vue?vue&type=template&id=b3b0408a&scoped=true"
import script from "./HorizontalStep.vue?vue&type=script&lang=js"
export * from "./HorizontalStep.vue?vue&type=script&lang=js"
import style0 from "./HorizontalStep.vue?vue&type=style&index=0&id=b3b0408a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b0408a",
  null
  
)

export default component.exports